import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@core/store/hooks';
import { selectIsAuthenticated } from '@features/auth';

/**
 * Protected Route Component.
 *
 * Redirects to /login if the user is not authenticated.
 */
export function ProtectedRoute() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
